import { MAX_IMAGE_SIZE } from '@showbie-socrative/socrative-utils';

import { sendTeacherAmplitudeEvent } from '~analytics/amplitude';
import { EventTypes } from '~analytics/types';

import { EventAdapter } from './EventAdapter';
import { ImageAddMethod, ImageUploadContext } from './ImageEventAdapterTypes';

interface ImageSizeExceededAdapterParams {
  file_size: number;
  max_allowed_size: number;
  width: number;
  height: number;
  context: ImageUploadContext;
  add_method: ImageAddMethod;
  file_type: string;
}

export class ExceededImageSizeEventAdapter extends EventAdapter {
  protected intercomEventKey = null;
  protected amplitudeEventFunction = sendImageSizeExceededEvent;

  constructor({
    file_size,
    width,
    height,
    context,
    add_method,
    file_type,
  }: Omit<ImageSizeExceededAdapterParams, 'max_allowed_size'>) {
    super();

    try {
      this.eventData = {
        file_size,
        max_allowed_size: MAX_IMAGE_SIZE,
        context,
        width,
        height,
        add_method,
        file_type,
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}

function sendImageSizeExceededEvent(data: ImageSizeExceededAdapterParams) {
  sendTeacherAmplitudeEvent(EventTypes.ImageSizeExceeded, data);
}
